import React from 'react';

import { Container, Title, Button } from 'ui/components/styled';
import { ArchivedCustomers, ArchivedCategories } from '../lists';
import { Modal } from 'ui/components/styled/NewModal';
import useMediaQuery from 'hooks/useMediaQuery';
import device from 'ui/theme/device';

export const ArchiveModal = ({ show, onRefresh, onClose, ...rest }) => {
  const isSmall = useMediaQuery(device.small);
  return (
    <Modal isOpen={show} onRequestClose={onClose} {...rest}>
      <Container>
        <Title variant="primary" fontSize="20px" fontWeight="500" mb="20px">
          Archive
        </Title>
        <Container>
          {show && (
            <>
              <ArchivedCustomers onRefresh={onRefresh} isSmall={isSmall} />
              <ArchivedCategories onRefresh={onRefresh} isSmall={isSmall} />
            </>
          )}
        </Container>
        <Container flexDirection="row" justifyContent="flex-end">
          <Button variant="contrast-primary" width="180px" onClick={onClose} boxShadow="none">
            Close
          </Button>
        </Container>
      </Container>
    </Modal>
  );
};
